import { memo } from 'react';
import { Stack, Select as MuiSelect, MenuItem, Typography, SxProps, Theme } from '@mui/material';
import { SelectInputProps } from '@mui/material/Select/SelectInput';
import { ResponsiveStyleValue } from './DialogTextField';

interface ISelectProps extends Partial<SelectInputProps> {
  label?: string;
  labelWidth?: number | string;
  width?: number | string;
  marginBottom?: string;
  selectList: { value: string; display?: string }[];
  select: string;
  stackDirection?: ResponsiveStyleValue<'row' | 'row-reverse' | 'column' | 'column-reverse'>;
}

function DialogSelect({
  label,
  labelWidth = '100px',
  width,
  marginBottom = '20px',
  selectList,
  select,
  stackDirection = { xs: 'column', sm: 'column', md: 'row' },
  ...others
}: ISelectProps) {
  const labelStyle: SxProps<Theme> = {
    color: 'mind.black.A0',
    minWidth: labelWidth,
    maxWidth: labelWidth,
    typography: 's13w800',
  };
  return (
    <Stack sx={{ marginBottom, marginTop: '1px' }} spacing="8px" direction={stackDirection} alignItems="center">
      {label && (
        <Typography
          sx={{
            ...labelStyle,
            maxWidth: { xs: '100%', sm: '100%', md: labelWidth },
            width: { xs: '100%', sm: '100%', md: labelWidth },
          }}
          noWrap
        >
          {label}
        </Typography>
      )}
      <MuiSelect
        {...others}
        value={select}
        sx={theme => ({
          width: width || '100%',
          height: 40,
          borderRadius: '4px',
          color: theme.palette.text.primary,
          '& .MuiSvgIcon-root': {
            right: '8px',
          },
          '& .MuiPopover-paper': {
            maxHeight: '200px',
          },
        })}
        MenuProps={{
          anchorOrigin: {
            vertical: 'bottom',
            horizontal: 'left',
          },
          transformOrigin: {
            vertical: 'top',
            horizontal: 'left',
          },
          sx: { '& .MuiMenu-paper': { maxWidth: '320px', maxHeight: '200px' } },
        }}
      >
        {selectList.map(({ value, display }) => (
          <MenuItem
            key={`${display}-${value}`}
            value={value}
            sx={{
              '&.MuiMenuItem-root': {
                maxWidth: 'calc(100%)',
                textOverflow: 'ellipsis',
                overflow: 'hidden',
                whiteSpace: 'nowrap',
                display: 'block',
              },
            }}
          >
            {display || value}
          </MenuItem>
        ))}
      </MuiSelect>
    </Stack>
  );
}

export default memo(DialogSelect);
